var map = {
	"./argentina.svg": 37,
	"./brazil.svg": 38,
	"./canada.svg": 39,
	"./france.svg": 40,
	"./germany.svg": 41,
	"./portugal.svg": 42,
	"./russia.svg": 43,
	"./sweden.svg": 44,
	"./ukraine.svg": 45,
	"./united-kingdom.svg": 46
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94;